import { render } from "./CalculationLondon.vue?vue&type=template&id=05236404&scoped=true"
import script from "./CalculationLondon.vue?vue&type=script&lang=js"
export * from "./CalculationLondon.vue?vue&type=script&lang=js"

import "./CalculationLondon.vue?vue&type=style&index=0&id=05236404&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05236404"]])

export default __exports__